import {
    FETCH_TOOL_SUCCESS,
    FETCH_TOOLS_SUCCESS,
    SEARCH_TOOLS_SUCCESS,
    UPDATE_TOOL_LOVES_SUCCESS,
    FETCH_SAVED_TOOLS_SUCCESS,
    FETCH_ALTERNATIVE_TOOLS_SUCCESS,
    FETCH_SUBMITTED_TOOLS_SUCCESS,
    FETCH_ADMIN_TOOLS_SUCCESS,
    FETCH_ADMIN_TOOLS_REQUEST,
    FETCH_ADMIN_TOOLS_FAILURE,
    UPDATE_TOOL_STATUS_SUCCESS,
    UPDATE_TOOL_INFO_SUCCESS,
    SUBMIT_TOOL_SUCCESS,
    FETCH_TOOL_DETAILS_SUCCESS,
    DELETE_TOOL_SUCCESS,
    SUBMIT_BATCH_TOOLS_SUCCESS,
    SUBMIT_BATCH_TOOLS_FAILURE,
} from "actions/tool";

const initialState = {
    toolsMap: {},
    tools: [],
    totalCount: 0,
    hasMore: true,
    searchResults: [],
    savedTools: [],
    alternativeTools: [],
    submittedTools: [],
    adminTools: [],
    adminToolsPagination: {
        total: 0,
        page: 1,
        limit: 20,
        totalPages: 0,
    },
    adminToolsLoading: false,
    adminToolsError: null,
    batchSubmitError: null,
};

const toolReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TOOL_SUCCESS:
            return {
                ...state,
                toolsMap: {
                    ...state.toolsMap,
                    [action.payload.name]: action.payload,
                },
            };
        case FETCH_TOOLS_SUCCESS:
            const isInitialLoad = action.payload.offset === 0;
            return {
                ...state,
                tools: isInitialLoad
                    ? action.payload.tools
                    : [...state.tools, ...action.payload.tools],
                totalCount: action.payload.totalCount,
                hasMore: action.payload.hasMore,
            };
        case SEARCH_TOOLS_SUCCESS:
            return {
                ...state,
                searchResults: action.payload,
            };
        case UPDATE_TOOL_LOVES_SUCCESS:
            return {
                ...state,
                toolsMap: Object.fromEntries(
                    Object.entries(state.toolsMap).map(([key, tool]) => [
                        key,
                        tool.id === action.payload.uuid
                            ? { ...tool, loves: action.payload.loves }
                            : tool,
                    ])
                ),
                tools: state.tools.map((tool) =>
                    tool.id === action.payload.uuid
                        ? { ...tool, loves: action.payload.loves }
                        : tool
                ),
                searchResults: state.searchResults.map((tool) =>
                    tool.id === action.payload.uuid
                        ? { ...tool, loves: action.payload.loves }
                        : tool
                ),
            };
        case FETCH_SAVED_TOOLS_SUCCESS:
            return {
                ...state,
                savedTools: action.payload,
            };
        case FETCH_ALTERNATIVE_TOOLS_SUCCESS:
            return {
                ...state,
                alternativeTools: action.payload,
            };
        case FETCH_SUBMITTED_TOOLS_SUCCESS:
            return {
                ...state,
                submittedTools: action.payload,
            };
        case FETCH_ADMIN_TOOLS_REQUEST:
            return {
                ...state,
                adminToolsLoading: true,
                adminToolsError: null,
            };
        case FETCH_ADMIN_TOOLS_SUCCESS:
            return {
                ...state,
                adminTools: action.payload.tools,
                adminToolsPagination: action.payload.pagination,
                adminToolsLoading: false,
                adminToolsError: null,
            };
        case FETCH_ADMIN_TOOLS_FAILURE:
            return {
                ...state,
                adminToolsLoading: false,
                adminToolsError: action.payload,
            };
        case UPDATE_TOOL_STATUS_SUCCESS:
            return {
                ...state,
                adminTools: state.adminTools.map((tool) =>
                    tool.uuid === action.payload.uuid
                        ? { ...tool, status: action.payload.status }
                        : tool
                ),
            };
        case UPDATE_TOOL_INFO_SUCCESS:
            return {
                ...state,
                adminTools: state.adminTools.map((tool) =>
                    tool.uuid === action.payload.uuid
                        ? { ...tool, ...action.payload }
                        : tool
                ),
            };
        case SUBMIT_TOOL_SUCCESS:
            return {
                ...state,
                adminTools: [...state.adminTools, action.payload],
            };
        case FETCH_TOOL_DETAILS_SUCCESS:
            return {
                ...state,
                adminTools: state.adminTools.map((tool) =>
                    tool.uuid === action.payload.uuid
                        ? { ...tool, ...action.payload }
                        : tool
                ),
            };
        case DELETE_TOOL_SUCCESS:
            return {
                ...state,
                adminTools: state.adminTools.filter(
                    (tool) => tool.uuid !== action.payload.uuid
                ),
            };
        case SUBMIT_BATCH_TOOLS_SUCCESS:
            return {
                ...state,
                batchSubmitError: null,
                // The tools list will be refreshed by fetchAdminTools
            };
        case SUBMIT_BATCH_TOOLS_FAILURE:
            return {
                ...state,
                batchSubmitError: action.payload,
            };
        default:
            return state;
    }
};

export default toolReducer;
